import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Bluelagoon } from "@bluelagoon";
import MainLayout from "../../Layouts/main";
import IntegrationBuilder from "./IntegrationBuilder";

export default function IntegrationBuilderPage() {
    const { integrationId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const visibility = location.state?.visibility || "public";
    const [editingIntegration, setEditingIntegration] = useState(null);
    const [loading, setLoading] = useState(!!integrationId);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!integrationId) return;
        setLoading(true);
        Bluelagoon.getCommunityIntegrations().then((res) => {
            const body = res?.data?.data || res?.data || {};
            const list = body.integrations || body || [];
            const found = Array.isArray(list) ? list.find((i) => i.id === integrationId) : null;
            if (found) setEditingIntegration(found);
            else setError(t("builder.notFound"));
            setLoading(false);
        }).catch((err) => { setError(err?.message || t("builder.loadError")); setLoading(false); });
    }, [integrationId]);

    const handleClose = () => navigate("/integrate/community");

    if (loading) {
        return (
            <MainLayout noPadding>
                <div className="flex items-center justify-center h-full">
                    <div className="w-6 h-6 border-2 border-purple-200 border-t-purple-600 rounded-full animate-spin" />
                </div>
            </MainLayout>
        );
    }

    if (error) {
        return (
            <MainLayout noPadding>
                <div className="flex flex-col items-center justify-center h-full gap-3">
                    <p className="text-sm text-red-600">{error}</p>
                    <button onClick={handleClose} className="text-sm text-blue-600 hover:underline">{t("builder.backToIntegrations")}</button>
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout noPadding>
            <IntegrationBuilder
                visibility={visibility}
                onClose={handleClose}
                editingIntegration={editingIntegration}
            />
        </MainLayout>
    );
}
